import { render, staticRenderFns } from "./currentNode.vue?vue&type=template&id=d3652d32&scoped=true"
import script from "./currentNode.vue?vue&type=script&lang=js"
export * from "./currentNode.vue?vue&type=script&lang=js"
import style0 from "./currentNode.vue?vue&type=style&index=0&id=d3652d32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3652d32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3652d32')) {
      api.createRecord('d3652d32', component.options)
    } else {
      api.reload('d3652d32', component.options)
    }
    module.hot.accept("./currentNode.vue?vue&type=template&id=d3652d32&scoped=true", function () {
      api.rerender('d3652d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordManage/components/currentNode.vue"
export default component.exports